module.exports = __webpack_public_path__ + "static/img/157.75ebc9e7.gif";